const getVersion = () => {
  const mayorMinor = process.env.REACT_APP_API_APP_VERSION;

  const environment = process.env.REACT_APP_ENV;

  let revision = 0;

  let prettyVersion = mayorMinor;

  if (environment === 'PROD') {
    revision = process.env.REACT_APP_API_APP_VERSION_REVISION;
  }

  prettyVersion += `.${revision}`;

  return prettyVersion;
};

export default getVersion;
